import { Button } from '@billy/design-system'
import { ReactPortal, useCallback } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

import { useImportedInvoiceDrawerActionsElement } from '../../../../context/importedInvoiceDrawerActions'

interface ImportedInvoiceApproveButtonProps {
  isApproving: boolean
  onClick: () => void
}

/** Rendered with the form it approves, and shown in the drawer header. */
export const ImportedInvoiceApproveButton = ({
  isApproving,
  onClick,
}: ImportedInvoiceApproveButtonProps): ReactPortal | null => {
  const { t } = useTranslation()
  const actionsElement = useImportedInvoiceDrawerActionsElement()

  const handleButtonClick = useCallback(() => {
    onClick()
  }, [onClick])

  if (!actionsElement) {
    return null
  }

  return createPortal(
    <Button disabled={isApproving} loading={isApproving} onClick={handleButtonClick}>
      {t('imported_invoices.review.action.approve')}
    </Button>,
    actionsElement,
  )
}
